import script from "./date-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-picker.vue?vue&type=script&setup=true&lang=ts"

import "./date-picker.vue?vue&type=style&index=0&id=767c2d1b&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767c2d1b"]])

export default __exports__
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDate});
